import { useState, useEffect } from "react";

// third-party import
import { useSelector } from "react-redux";

// project-import
import { formatDateWithSuffixV2, getOrCreateGuestId, slugify } from "../../utils";
import { useBlogContext } from "../../context/blog_context";
import {
    GoogleAnalyticsEnum,
    triggerFunction,
} from "../../utils/google-analytics";
import ModalLogin from "../form/ModalLogin";
import Spinner from "../../components/spinner-component/SpinnerOne";
import ToolTip from "../../common/Tooltip/ToolTip";
import InteractionComponent from "../reusable/InteractionComponent";
import BookmarkComponent from "../reusable/BookmarkComponent";

export default function KnowledgeCard({ data, onReadMore }) {
    const { loginData } = useSelector((item) => item.user);
    const { updateBlogLikes, isLikeUpdating, blogs } = useBlogContext();

    const [liked, setLiked] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [isLoggedOut, setIsLoggedOut] = useState(false);
    const [likesCount, setLikesCount] = useState(0);

    // Construct like data Added By Longswitch Team Start
    const member = (loginData && loginData.data) || null;
    const currentUserId = member
        ? member?.userRecordId || ""
        : getOrCreateGuestId();

    useEffect(() => {

        if (!data) {
            return;
        }

        // Set Auto Likes
        let likes = [
            ...(data?.likes || [])
        ];


        const index =
            (likes || []).findIndex(
                (item) =>
                    item?.userId ===
                    currentUserId && item?.isLiked === true
            );

        if (index !== -1) {
            setLiked(true);
        } else {
            setLiked(false);
        }

        // likes count
        const filteredLikes = (likes || []).filter(
            (item) =>
                item?.isLiked === true
        );
        setLikesCount(filteredLikes?.length);
    }, [data]);

    useEffect(() => {

        if (!data) {
            return;
        }

        let updatedBlogs = (blogs || []).filter((item) =>
            item?.id === data?.id
        );

        if (updatedBlogs && updatedBlogs.length) {
            // Set Auto Likes
            let likes = [
                ...(updatedBlogs[0]?.likes || [])
            ];


            const index =
                (likes || []).findIndex(
                    (item) =>
                        item?.userId ===
                        currentUserId && item?.isLiked === true
                );

            if (index !== -1) {
                setLiked(true);
            } else {
                setLiked(false);
            }

            // likes count
            const filteredLikes = (likes || []).filter(
                (item) =>
                    item?.isLiked === true
            );
            setLikesCount(filteredLikes?.length);
        }

    }, [blogs]);

    const handleShare = async () => {
        // const shareUrl = window.location.href;
        const slug = encodeURIComponent(data?.title?.toLowerCase()?.replace(/ /g, '-'));

        const shareUrl = `/salesforce-quick-insights/${slug}`;

        const shareData = {
            title: data?.title || "Longswitch Academy",

            text: `Check out this Salesforce insight from Longswitch Academy: ${data?.title || ""
                }`,

            url: shareUrl,
        };

        // Native sharing
        if (navigator.share) {
            try {
                await navigator.share(shareData);

                return;
            } catch (error) {
                if (error?.name === "AbortError") {
                    return;
                }
            }
        }

        // Clipboard fallback
        try {
            await navigator.clipboard.writeText(shareUrl);

            setIsCopied(true);

            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (error) {
            console.error("Unable to copy article link:", error);
        }
    };

    const handleLikeBtnClick = (value) => {
        try {
            if (!member) {
                return openModalLogin();
            }

            let likes = [...(data?.likes || [])];
            const index = likes.findIndex((item) => item.userId === currentUserId);
            if (index !== -1) {
                likes = likes.map((like, i) =>
                    i === index
                        ? { ...like, count: value ? 1 : 0, isLiked: value }
                        : like,
                );
            } else {
                likes.push({
                    userId: currentUserId,
                    count: value ? 1 : 0,
                    isLiked: value,
                    idValue: data ? data?.id : "",
                    id: data ? data?.id : "",
                });
            }

            if (likes && likes.length) {
                updateBlogLikes(data ? data?.id : "", likes);
                triggerFunction(
                    window.location.pathname + " " + GoogleAnalyticsEnum.BUTTON,
                    GoogleAnalyticsEnum.LSA_SALESFORCE_BLOG_LIKE_ADDED,
                );
            }
        } catch (error) {
            console.error("Error while updating likes => ", error);
        }
    };

    const openModalLogin = () => setIsLoggedOut(true);
    const closeModalLogin = () => setIsLoggedOut(false);

    return (
        <article className="knowledge-card">
            {isLikeUpdating && <Spinner />}
            {/* CONTENT */}
            <div className="knowledge-card-content">

                <div className="d-flex justify-content-between">
                    <div className="">
                        <span className="knowledge-card-category blog-tag p-0">
                            {data?.tags?.slice(0, 1).map((tag, i) => {
                                return (
                                    <a key={i} className="cursor-initial interview-header-badge fs-9 text-white">
                                        {tag?.toUpperCase() || ""}
                                    </a>
                                );
                            })}
                        </span>
                    </div>

                    <div>
                        <BookmarkComponent selectedArticle={data} openModalLogin={openModalLogin} />
                    </div>
                </div>


                <ToolTip title={data?.title} placement="bottom">
                    <h6 className="fs-17 mb--10 truncate-2-lines quick-insight-title">{data?.title || ""}</h6>
                </ToolTip>

                {/* META */}
                <div className="knowledge-card-meta mb--10">
                    <div className="knowledge-card-meta-item">
                        <i className="ri ri-calendar-line"></i>

                        <span>{formatDateWithSuffixV2(data?.publishedAt)}</span>
                    </div>

                    <div className="knowledge-card-meta-item">
                        <i className="ri ri-time-line"></i>

                        <span>{data.readingTime}</span>
                    </div>


                </div>

                <p className="knowledge-card-description truncate-2-lines">
                    {data?.quickInsight}
                </p>
                <div className="text-center mb--10">
                    <a
                        // href="#"
                        onClick={() => onReadMore(data)}
                        className="knowledge-card-read-more btn-transparent-2 color-heading clickable"
                    >
                        Read More
                        <i className="icon-arrow-right-line-right"></i>
                    </a>
                </div>

                <div className="fw-bolder border-0 border-bottom" />

                <div className="mt--5">
                    <InteractionComponent selectedArticle={data} openModalLogin={openModalLogin} />
                </div>

            </div>

            {/* ACTIONS */}
            {/* <div className="knowledge-card-actions align-items-center">
                <div className="d-flex justify-space-between flex-column">
                    <button
                        type="button"
                        className="knowledge-card-action-btn"
                        onClick={handleShare}
                        title={isCopied ? "Link copied" : "Share article"}
                        aria-label="Share article"
                    >
                        <i className="ri-share-line"></i>
                    </button>

                    <div className="d-flex flex-column align-items-center">
                        <button
                            type="button"
                            className={`knowledge-card-action-btn mt--5 mb--2 ${liked ? "active" : ""}`}
                            onClick={() => handleLikeBtnClick(!liked)}
                            aria-label={liked ? "Unlike" : "Like"}
                            disabled={isLikeUpdating}
                        >
                            <i
                                className={
                                    liked
                                        ? "ri-heart-fill text-danger"
                                        : "ri-heart-line text-danger"
                                }
                            ></i>
                        </button>
                        <small className="text-muted fs-6">
                            {likesCount}
                        </small>
                    </div>

                </div>
                <a
                    // href="#"
                    onClick={() => onReadMore(data)}
                    className="knowledge-card-read-more btn-transparent-2 color-primary clickable"
                >
                    Read More
                    <i className="icon-arrow-right-line-right"></i>
                </a>
            </div> */}


            <ModalLogin
                show={isLoggedOut}
                onCloseModalLogin={closeModalLogin}
                title={`Login to Interact the Salesforce Quick Insight`}
            />
        </article>
    );
}
